import React from "react";
import I18n from "i18n-js";

import HealthSection from "./HealthSection";

import leadershipHealthIcon from "../../assets/icons/leadership-health.svg";

import trustEnvironmentIcon from "../../assets/images/trust-environment.svg";
import managementPracticeIcon from "../../assets/images/management-practice.svg";

const getKPIs = (trustEnvironment, managementPractice) => [
  {
    title: I18n.t("dashboard.leadership_health.trust_environment.title"),
    score: trustEnvironment?.score,
    indicator: trustEnvironment?.indicator,
    message: trustEnvironment?.message,
    icon: trustEnvironmentIcon,
    about: I18n.t("dashboard.leadership_health.trust_environment.about"),
  },
  {
    title: I18n.t("dashboard.leadership_health.management_practice.title"),
    score: managementPractice?.score,
    indicator: managementPractice?.indicator,
    message: managementPractice?.message,
    icon: managementPracticeIcon,
    about: I18n.t("dashboard.leadership_health.management_practice.about"),
  }
];

const LeadershipHealth = ({ trustEnvironment, managementPractice, ofuscate, expand }) => {
  const classNames = expand ? "leadership-health-section expand" : "leadership-health-section";
  return (
    <div className={classNames}>
      <HealthSection
        icon={leadershipHealthIcon}
        title={I18n.t("dashboard.leadership_health.title")}
        kpis={getKPIs(trustEnvironment, managementPractice)}
        ofuscate={ofuscate}
      />
    </div>
  );
}

export default LeadershipHealth;
